import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/GoogleMap";

export const GetAddressWithCoordinate = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAddressWithCoordinate`, options);

export const GetAddressWithAddress = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAddressWithAddress`, options);

export default {
  GetAddressWithCoordinate,
  GetAddressWithAddress,
};
